import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-minimal-layout',
  imports: [RouterOutlet],
  templateUrl: './minimal-layout.component.html',
  styleUrl: './minimal-layout.component.scss',
})
export class MinimalLayoutComponent {


}
